(function(){
  const root = document.querySelector('[data-ccm-premium-navbar]');
  if (!root) return;

  const shell = root.querySelector('[data-ccm-navbar-shell]');
  const nav = root.querySelector('[data-ccm-premium-nav]');
  const follower = root.querySelector('[data-ccm-nav-follower]');
  const links = nav ? Array.from(nav.querySelectorAll('.ccm-premium-navbar__nav-link')) : [];
  const megaTrigger = root.querySelector('[data-ccm-mega-trigger]');
  const mega = root.querySelector('[data-ccm-mega-menu]');
  const drawerToggle = root.querySelector('[data-ccm-drawer-toggle]');
  const drawer = root.querySelector('[data-ccm-mobile-drawer]');
  const modeButtons = Array.from(document.querySelectorAll('[data-ccm-theme-mode]'));
  const region = root.querySelector('[data-ccm-region]');
  const regionToggle = root.querySelector('[data-ccm-region-toggle]');
  const regionMenu = root.querySelector('[data-ccm-region-menu]');
  const regionForm = root.querySelector('#CCMRegionLocalizationForm');
  const regionInput = regionForm?.querySelector('[data-ccm-region-input]');
  const regionOptions = Array.from(root.querySelectorAll('[data-ccm-region-option]'));
  const THEME_STORAGE_KEY = 'ccm-theme-mode';

  function getStoredTheme(){
    try {
      const value = window.localStorage.getItem(THEME_STORAGE_KEY);
      return value === 'dark' || value === 'light' ? value : null;
    } catch (_) {
      return null;
    }
  }

  function storeTheme(mode){
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, mode);
    } catch (_) {}
  }

  function isDesktop(){
    return window.matchMedia('(min-width: 901px)').matches;
  }

  function setLightPreview(isLight, persist){
    const mode = isLight ? 'light' : 'dark';
    if (persist) storeTheme(mode);
    document.documentElement.setAttribute('data-ccm-theme', mode);
    document.body.classList.toggle('ccm-light-preview', isLight);
    document.body.classList.toggle('theme-light', isLight);
    document.body.classList.toggle('theme-dark', !isLight);

    const home = document.querySelector('.ccm-home-page');
    if (home) {
      home.classList.toggle('theme-light', isLight);
      home.classList.toggle('theme-dark', !isLight);
      home.setAttribute('data-ccm-mode', isLight ? 'light' : 'dark');
    }

    document.querySelectorAll('[data-ccm-product-v5]').forEach((productRoot) => {
      productRoot.classList.toggle('theme-light', isLight);
      productRoot.classList.toggle('theme-dark', !isLight);
      productRoot.setAttribute('data-ccm-mode', isLight ? 'light' : 'dark');
    });

    modeButtons.forEach((button) => {
      button.classList.toggle('active', button.dataset.ccmThemeMode === (isLight ? 'light' : 'dark'));
    });

    document.querySelectorAll('.modeBtn').forEach((button) => {
      const mode = button.dataset.theme || button.dataset.mode;
      button.classList.toggle('active', mode === (isLight ? 'light' : 'dark'));
    });
  }

  function moveFollowerTo(link){
    if (!nav || !follower || !link || !isDesktop()) return;
    const navRect = nav.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();
    const isActive = link.classList.contains('active');
    follower.style.left = `${linkRect.left - navRect.left}px`;
    follower.style.width = `${linkRect.width}px`;
    follower.classList.add('is-visible');
    follower.classList.toggle('is-active', isActive);
    nav.classList.toggle('follower-on-active', isActive);
  }

  function moveFollowerToActive(){
    if (!nav || !follower) return;
    const active = nav.querySelector('.ccm-premium-navbar__nav-link.active');
    if (active && isDesktop()) {
      moveFollowerTo(active);
      return;
    }
    follower.classList.remove('is-visible', 'is-active');
    nav.classList.remove('follower-on-active');
  }

  function setMega(open){
    if (!mega || !megaTrigger) return;
    const next = Boolean(open) && isDesktop();
    mega.classList.toggle('is-open', next);
    megaTrigger.setAttribute('aria-expanded', String(next));
  }

  function setDrawer(open){
    if (!drawer || !drawerToggle) return;
    drawer.classList.toggle('is-open', Boolean(open));
    drawerToggle.setAttribute('aria-expanded', String(Boolean(open)));
  }

  function setRegion(open){
    if (!region || !regionToggle) return;
    const next = Boolean(open);
    region.classList.toggle('is-open', next);
    regionToggle.setAttribute('aria-expanded', String(next));
  }

  links.forEach((link) => {
    link.addEventListener('mouseenter', () => moveFollowerTo(link));
    link.addEventListener('focus', () => moveFollowerTo(link));
  });

  nav?.addEventListener('mouseleave', moveFollowerToActive);
  nav?.addEventListener('focusout', (event) => {
    if (!nav.contains(event.relatedTarget)) moveFollowerToActive();
  });

  megaTrigger?.addEventListener('mouseenter', () => setMega(true));
  mega?.addEventListener('mouseenter', () => setMega(true));
  mega?.addEventListener('mouseleave', () => setMega(false));
  megaTrigger?.addEventListener('click', (event) => {
    if (!isDesktop()) return;
    if (!mega?.classList.contains('is-open')) {
      event.preventDefault();
      setMega(true);
    }
  });

  drawerToggle?.addEventListener('click', () => {
    setDrawer(!drawer?.classList.contains('is-open'));
  });

  regionToggle?.addEventListener('click', () => {
    setRegion(!region?.classList.contains('is-open'));
  });

  regionOptions.forEach((option) => {
    option.addEventListener('click', () => {
      const countryCode = option.dataset.ccmRegionOption;
      if (!countryCode || !regionForm || !regionInput) return;
      regionInput.value = countryCode;
      setRegion(false);
      if (typeof regionForm.requestSubmit === 'function') regionForm.requestSubmit();
      else regionForm.submit();
    });
  });

  modeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setLightPreview(button.dataset.ccmThemeMode === 'light', true);
    });
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.modeBtn[data-theme], .modeBtn[data-mode]');
    if (!button) return;
    const mode = button.dataset.theme || button.dataset.mode;
    if (mode === 'light' || mode === 'dark') setLightPreview(mode === 'light', true);
  }, true);

  document.addEventListener('click', (event) => {
    if (mega && megaTrigger && mega.classList.contains('is-open') && !mega.contains(event.target) && !megaTrigger.contains(event.target)) {
      setMega(false);
    }
    if (drawer && drawerToggle && drawer.classList.contains('is-open') && !drawer.contains(event.target) && !drawerToggle.contains(event.target)) {
      setDrawer(false);
    }
    if (region && regionToggle && region.classList.contains('is-open') && !region.contains(event.target)) {
      setRegion(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setMega(false);
    setDrawer(false);
    setRegion(false);
  });

  window.addEventListener('scroll', () => {
    shell?.classList.toggle('is-scrolled', window.scrollY > 16);
  }, { passive:true });

  window.addEventListener('resize', () => {
    setMega(false);
    setDrawer(false);
    setRegion(false);
    moveFollowerToActive();
  });

  const storedTheme = getStoredTheme();
  setLightPreview(storedTheme ? storedTheme === 'light' : (document.body.classList.contains('ccm-light-preview') || document.body.classList.contains('theme-light')));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveFollowerToActive, { once:true });
  } else {
    moveFollowerToActive();
  }
  window.addEventListener('load', moveFollowerToActive);
  window.setTimeout(moveFollowerToActive, 90);
})();
